import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';

import { ta } from '../../i18n/adminT';
export default function LogoManager() {
  const [logoUrl, setLogoUrl] = useState(null);
  const [error, setError] = useState('');
  const [uploading, setUploading] = useState(false);

  const [scale, setScale] = useState(100);
  const [scaleSaving, setScaleSaving] = useState(false);
  const [scaleSaved, setScaleSaved] = useState(false);
  const [scaleError, setScaleError] = useState('');

  const load = async () => {
    const res = await api.getLogo().catch(() => null);
    setLogoUrl(res?.logoUrl || null);
    setScale(res?.scale || 100);
  };

  useEffect(() => { load(); }, []);

  const handleUpload = async (file) => {
    if (!file) return;
    setError('');
    setUploading(true);
    try {
      const res = await api.uploadLogo(file);
      setLogoUrl(res.logoUrl);
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(false);
    }
  };

  const handleSaveScale = async () => {
    setScaleError('');
    setScaleSaved(false);
    setScaleSaving(true);
    try {
      await api.saveLogoScale(scale);
      setScaleSaved(true);
    } catch (err) {
      setScaleError(err.message);
    } finally {
      setScaleSaving(false);
    }
  };

  const previewSize = 90 * (scale / 100);

  return (
    <div>
      <h1 className="admin-page-title">{ta('Logo personalizzato')}</h1>
      <p className="admin-page-subtitle">{ta('Il logo caricato qui compare nel pannello utente e in quello amministratore.')}</p>

      {error && <div className="form-error">{error}</div>}

      <div className="admin-card" style={{ maxWidth: 420 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 100, marginBottom: 18 }}>
          {logoUrl ? (
            <img src={logoUrl} alt={ta('Logo attuale')} style={{ height: previewSize, maxWidth: '100%' }} />
          ) : (
            <span style={{ color: 'var(--muted-text)' }}>{ta('Nessun logo caricato')}</span>
          )}
        </div>
        <div className="upload-drop">
          <label htmlFor="logo-upload">{uploading ? ta('Caricamento…') : ta('Carica nuovo logo')}</label>
          <input id="logo-upload" type="file" accept="image/png,image/jpeg,image/svg+xml,image/webp" onChange={(e) => handleUpload(e.target.files[0])} />
          <p style={{ fontSize: '0.78rem', color: 'var(--muted-text)', marginTop: 8 }}>{ta('PNG, JPEG, SVG o WEBP · max 5MB')}</p>
        </div>
      </div>

      <div className="admin-card" style={{ maxWidth: 420 }}>
        <h3 style={{ marginBottom: 10 }}>{ta('Dimensione del logo')}</h3>
        <p style={{ fontSize: '0.85rem', color: 'var(--muted-text)', marginBottom: 14 }}>
          {ta('Percentuale di ingrandimento rispetto alla dimensione normale: 100% è la dimensione predefinita, valori più alti lo rendono più grande ovunque compaia (pannello utente, pagina Contatti, pannello amministratore).')}
        </p>

        {scaleError && <div className="form-error">{scaleError}</div>}
        {scaleSaved && (
          <div style={{ background: 'rgba(62,142,126,0.12)', color: 'var(--teal-green-dark)', borderRadius: 'var(--radius-control)', padding: '10px 14px', fontSize: '0.85rem', marginBottom: 16 }}>
            {ta('Salvato.')}
          </div>
        )}

        <div className="field">
          <label htmlFor="logo-scale">{ta('Percentuale:')} {scale}%</label>
          <input
            id="logo-scale"
            type="range"
            min={50}
            max={300}
            step={5}
            value={scale}
            onChange={(e) => { setScale(parseInt(e.target.value, 10)); setScaleSaved(false); }}
            style={{ width: '100%' }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.75rem', color: 'var(--muted-text)' }}>
            <span>50%</span>
            <span>100%</span>
            <span>300%</span>
          </div>
        </div>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSaveScale}
          disabled={scaleSaving}
          style={{ width: 'auto', padding: '10px 20px' }}
        >
          {scaleSaving ? ta('Salvataggio…') : ta('Salva')}
        </button>
      </div>
    </div>
  );
}
